import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services/api.service';
import {environment} from '../../../environments/environment';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';

import { SearchPageColumnsSearch } from '../models/search-page-columns.model';

@Injectable({
    providedIn: 'root'
  })
  export class SearchPageColumnsService{
      constructor(
          private http: HttpClient,
          private apiService: ApiService
      ) { }
      public searchSearchPageColumns(pageNo:number,pageSize:number,sortField:string,sortOrder:string,appliedFilters:{field:string,matchMode:string,value:string}[]=[]):Observable<any> {
        return this.apiService.get(`SearchPageColumns/SearchSearchPageColumns?pageNo=${pageNo}&pageSize=${pageSize}&sortField=${sortField}&sortOrder=${sortOrder}&appliedFilters=${appliedFilters}`)
      }
      public getAllSearchPageColumns(searchPageColumnParam:IGlobalSearchParam):Observable<any>{
        console.log(searchPageColumnParam);
        return this.apiService.post(`SearchPageColumns/SearchSearchPageColumns`, searchPageColumnParam)
      }
      public getSearchPageColumnsBySearchPageId(searchPageId: number):Observable<any>{
        return this.apiService.get(`SearchPageColumns/ColumnsBySearchPageId${searchPageId}`)
      }
      public getSearchPageColumnsById(columnId:number):Observable<any>{
        return this.apiService.get(`SearchPageColumns/${columnId}`)
      }
      public postSearchPageColumns(searchPageColumns:SearchPageColumnsSearch):Observable<any>{
        console.log(searchPageColumns);
        return this.apiService.post(`SearchPageColumns`,searchPageColumns )
      }
      public updateSearchPageColumns(columnId: number, searchPageColumns:SearchPageColumnsSearch):Observable<any>{
        return this.apiService.put(`SearchPageColumns/${columnId}`, searchPageColumns)
      }
      public deleteSearchPageColumns(columnId: number):Observable<any>{
        return this.apiService.delete(`SearchPageColumns/${columnId}`)
      }
      // public deleteSearchPageColumns(value:SearchPageColumnsSearch):Observable<any>{
      //   return this.apiService.delete(`SearchPageColumns`, value)
      // }
  }